export enum ViewContext {
	'Country' = 'Country',
	'City' = 'City',
	'Community' = 'Community',
	'Sector' = 'Sector',
	'Plot' = 'Plot',
	'Building' = 'Building',
	'Floor' = 'Floor',
	'Unit' = 'Unit',
	'Asset' = 'Asset',
}